import React, { Component } from "react";
import _ from "lodash";

import styles from "./ErrorOverlay.scss";

class ErrorOverlay extends Component {
  constructor(props) {
    super(props);
  }

  close = () => {
    const { onClose } = this.props;

    onClose();
  };

  render() {
    const error = _.toLower(this.props.error);

    return (
      <div className={styles.overlay}>
        <h3>This project is no longer available</h3>
        <div className={styles.divider} />
        <div className={styles.subheading}>
          {error !== "resource could not be found." &&
            "Another member was selected or it was paused or canceled. " +
              "Please check your other matches for more projects."}
        </div>

        <button type="button" className={styles.close} onClick={this.close}>
          Close
        </button>
      </div>
    );
  }
}

export default ErrorOverlay;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/components/pitchItForm/ErrorOverlay.js